const $$splitComponentImporter = () => import('/home/runner/work/upple-client-v2/upple-client-v2/src/routes/cm/internal/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/cm/internal')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});

/**
 * 내부 CPM 전용 화면의 공통 가드.
 *
 * 전사 고객사 데이터, 이메일 템플릿·수동 발송처럼 외부 CPM 에게 열면 안 되는 화면은 모두 이 아래에 둔다.
 * 실제 접근 차단은 백엔드(InternalCoachingManagerGuard)가 하고, 여기서는 화면 진입만 막는다.
 * 인증 로딩 중에는 부모 /cm 의 ProtectedRoute 가 아무것도 그리지 않으므로 여기서는 판정만 한다.
 */
export function TSRDummyComponent() {
  return null;
}